import { put, takeEvery, takeLatest, cancel, call } from 'redux-saga/effects';
import service from '../../services';
import { authError, authFetch, authSetDuo, authSuccess, authDuoFetchAction } from "../API/actions";
import { chooseServiceGenerator } from './utils';
import { API_DO_AUTH, API_CANCEL_AUTH, API_AUTH_DUO_SUCCESS } from '../../constants/API';
import loadData from './initialDataSaga';

function* authCatchError(err) {
  try {
    if (window.location.protocol === 'http:') {
      yield fetch(`http://${window.CONFIG.ServerAddress}:${window.CONFIG.OMSHTTPPort}/heartbeat`);
    }
    yield put(authError(err.message));
  } catch (e) {
    yield put(authFetch());
    yield put(authError(`<span class="server">${window.CONFIG.ServerAddress}:${window.CONFIG.ServerPort}</span> server is not responding or cannot be reached.`, 'Network Error'));
  }
}

function* authDuoSaga(payload, action) {
  try {
    const data = yield call(() => service.duoLogin(payload.token, action.sigResponse));
    data.token2 ? yield put(authSuccess(payload.username, payload.token, data.token2))
      : yield put(authError('Duo login failed.'));
  } catch (err) {
    yield call(authCatchError, err);
  }
}

function* authOcularisSaga(action) {
  const {headers} = action;
  const {username, password} = headers;

  try {
    yield put(authFetch());

    const data = yield service.login({username, password, cancelId: service.generateId()});
    if (data.duo_enabled) {
      if (data.duo_host && data.sig_request) {
        yield put(authSetDuo(data.duo_host, data.sig_request));
        yield put(authDuoFetchAction());

        yield takeEvery(API_AUTH_DUO_SUCCESS, authDuoSaga, {token: data.token, username: username})
      } else {
        yield put(authError('Duo credentials is not defined!'));
      }
    } else {
      data.token ? yield put(authSuccess(headers.username, data.token))
        : yield put(authError(data.result));
    }
  } catch (err) {
    yield call(authCatchError, err);
  }
}

function* authCayugaSaga(action) {
  const {headers} = action;
  const {username, password} = headers;

  try {
    yield put(authFetch());

    const data = yield service.login({username, password, cancelId: service.generateId()});
    !data.error ? yield put(authSuccess(username, data.data))
      : yield put(authError(data.data));
  } catch (err) {
    yield put(authError(err.message));
  }
}


function* auth(authSaga, action) {
  const authTask = yield call(authSaga, action);
  const loadDataTask = yield call(loadData);
  yield takeLatest(API_CANCEL_AUTH, cancelAuth, [authTask, loadDataTask], authSaga);
}

function* cancelAuth(oldTasks, authTask, service) {
  yield cancel([...oldTasks]);
  yield service.cancelAllRequests();
  const newAuthTask = yield takeEvery(API_DO_AUTH, authTask);
  const newLoadDataTask = yield takeEvery(API_DO_AUTH, loadData);
  yield takeLatest(API_CANCEL_AUTH, cancelAuth, [newAuthTask, newLoadDataTask]);
}

function* doAuth() {
  yield takeEvery(API_DO_AUTH, chooseServiceGenerator,
    {fn: auth, args: [authOcularisSaga]},
    {fn: auth, args: [authCayugaSaga]}
  );
}

export default doAuth;